<template>
  <div>
    <iframe
      src="/apps/cryptid-solver/index.html"
      width="100%"
      height="800px"
      frameborder="0"
    ></iframe>
    <div id="header">
      <h1>{{ $t("pageTitle") }}</h1>
    </div>
    <div id="content">
      <h3>Pelin kuvaus</h3>
      <p>
        Cryptidissä pelaajat ovat kryptozoologeja, jotka yrittävät etsiä jotain
        mystistä olentoa. Kukin pelaaja tietää yhden vihjeen siitä, missä olento
        voisi olla, mutta tarkan paikan selvittämiseen pelaajan pitää päätellä
        myös muiden pelaajien vihjeet. Pelaaja, joka ensimmäisenä löytää tarkan
        sijainnin, voittaa pelin.
      </p>
      <h3>Mikä tämä sovellus on?</h3>
      <p>
        Apusovellus Cryptid -lautapeliin. Sovelluksen avulla pystyy etsimään
        kaikki ratkaisut jokaiseen laudan konfiguraation.
      </p>
      <h3>Motivaatio</h3>
      <p>
        Halusin selvittää, miten monta eri ratkaisua samalla kartta
        konfiguraatiolla voi olla. Pelissä ei ole satunnaisia tekijöitä, joten
        tällaisen työkalun tekeminen vaikutti kiinnostavalta haasteelta.
      </p>
      <p>
        Kirjoitus hetkellä en ole panostanut juurikaan käyttöliittymään, koska
        tein sovelluksen omasta mielenkiinnosta ja en ajatellut sen julkaisua.
        Jos tätä jollain tavalla lähtisi jatkokehittämään, käyttöliittymä olisi
        varmasti yksi ensimmäisistä kehityskohdista.
      </p>
      <p>
        Tämä sovelluksen löytää myös osoitteesta
        <a href="https://cryptid.hynale.fi">https://cryptid.hynale.fi</a>
      </p>
      <h3>Kuinka käytetään?</h3>
      <p>
        Pelin säännöt selviää ja uusia pohjakarttoja luoda seuraavasta linkistä:
        <a href="https://ospreypublishing.com/playcryptid/" target="_blank"
          >Play Cryptid - Osprey Publishing</a
        >
      </p>
      <p>
        <code>Map layout</code> kohtaan syötettään kartta koodi, joka generoi
        kartan. Formaatin kanssa pitää olla tarkka. Koodin pitää sisältää luvut
        1-6 eroteltuna pilkulla ilman välilyöntejä. Yksittäinen kirjain
        <i>f</i> numeron perässä on sallittu. Esimerkiksi koodi
        <code>6,2f,5,4,3,1</code> tulostaa kartan, jossa karttalaatat on
        asetettu seuraavasti:
      </p>
      <table class="mapTable">
        <tbody>
          <tr>
            <td>6</td>
            <td class="flipped">2</td>
          </tr>
          <tr>
            <td>5</td>

            <td>4</td>
          </tr>
          <tr style="border-bottom: 1px solid black;">
            <td>3</td>
            <td>1</td>
          </tr>
        </tbody>
      </table>
      <p>
        Kirjain <i>f</i> tarkoittaa sitä, että karttalaatta on käännetty 180
        astetta. Paina <code>Draw tiles</code>, niin kartta piirtyy sivun
        alaosaan.
      </p>
      <p>
        Rakennukset tulee asettaa kartan eri heksoille. Yhdellä heksalla saa
        olla vain yksi rakennus, mutta toisaalta tämä implementaatio ei rajoita
        tätä. Piirtyneestä kartasta voi tarkistaa koordinaatit, joihin
        rakennukset voi asettaa. Mustia rakennuksia käytetään vain kehittyneessä
        pelivariantissa. Paina sitten <code>Apply structures</code>.
      </p>
      <p>
        Lopuksi voit asettaa ensimmäisen vihjeen. Usein tämä vihje olisi se,
        jonka pelaaja saa pelin alussa. Tämä ei ole pakollinen sovelluksen
        toiminnan kannalta, mutta sen asettaminen nopeuttaa ratkaisujen hakua.
        Paina lopuksi <code>Find solutions</code>. Tämä tulostaa kaikki
        mahdolliset vaihtoehdot. Tuloksia pystyy rajaamaan valitsemalla sivun
        reunasta lisää vinkkejä.
      </p>
    </div>
  </div>
</template>

<script>
import { i18nMixin } from "@/vue/mixins/i18nMixin";

export default {
  mixins: [i18nMixin],
  methods: {},
  data() {
    return {};
  },
  metaInfo: {
    meta: [
      { charset: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      { content: "Cryptid", property: "og:title" }
    ]
  }
};
</script>

<style lang="scss" scoped></style>

<i18n>
{
    "en": {
        "pageTitle": "Cryptid Solver",
        "description": ""
    },
    "fi": {
        "pageTitle": "Cryptid Ratkaisin",
        "description": ""
    }
}
</i18n>

<style scoped>
.mapTable {
  width: 8em;
}
.mapTable td {
  border: 1px solid black;
  width: 2em;
  text-align: center;
}
.flipped {
  transform: rotate(180deg);
}
</style>
